import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Sidebar.css';
import logo from '../assets/vaahanBuddyLogo.png';

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const [isMobile, setIsMobile] = useState(false);

  const menuItems = [
    { name: 'Dashboard', path: '/', icon: 'th-large' },
    { name: 'Users', path: '/users', icon: 'users' },
    { name: 'Vehicles', path: '/vehicles', icon: 'car' },
    { name: 'Service Requests', path: '/service-requests', icon: 'clipboard-list' },
    { name: 'Partners', path: '/partner', icon: 'handshake' },
    { name: 'Notifications', path: '/notifications', icon: 'bell' },
    { name: 'App Settings', path: '/config', icon: 'cog' },
    { name: 'Challan', path: '/challan', icon: 'file-invoice' },
    { name: 'RC Search History', path: '/search', icon: 'history' },
    { name: 'Challan Search Audits', path: '/search-challans', icon: 'list-alt' }
  ];

  const { user, logout } = useAuth();

  if (user?.isSuperAdmin) {
    menuItems.splice(2, 0, { name: 'Admin Management', path: '/admin-management', icon: 'user-shield' });
  }

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleLinkClick = () => {
    if (isMobile && toggleSidebar) {
      toggleSidebar();
    }
  };

  return (
    <>
      {isMobile && isOpen && (
        <div className="sidebar-overlay" onClick={toggleSidebar}></div>
      )}

      <div className={`sidebar ${isOpen ? 'sidebar-open' : ''}`}>
        <div className="sidebar-header">
          <img src={logo} alt="VaahanBuddy Admin Logo" className="sidebar-logo" />
        </div>

        <div className="sidebar-content">
          <ul className="sidebar-menu">
            {menuItems.map((item) => (
              <li key={item.name} className="sidebar-menu-item">
                <NavLink
                  to={item.path}
                  className={({ isActive }) =>
                    `sidebar-link ${isActive ? 'sidebar-link-active' : ''}`
                  }
                  onClick={handleLinkClick}
                >
                  <i className={`fas fa-${item.icon}`}></i>
                  <span className="link-text">{item.name}</span>
                </NavLink>
              </li>
            ))}
          </ul>
        </div>

        <div className="sidebar-footer">
          <button className="sidebar-logout" onClick={logout}>
            <i className="fas fa-sign-out-alt"></i>
            <span>Logout</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default Sidebar;